// ****************************** Import From AWS Amplify ******************************** //

import '/src/amplify-config';

// ***************** CSS & Images ******************** //

import "./checkout.css";

// ********************* Images ********************** //

import "/src/assets/general-icons/left-arrow.svg";
import "/src/assets/box-designs/original-checked-pattern.svg";
import "/src/assets/images/fp-box-3028.jpg";

// ************ Add Top Nav & Footer ***************** //

import '/src/nav-header-footer/nav-header-footer.js';
import '/src/nav-header-footer/nav-header-footer.css';

// ************************ Item Quantities & Cost *************************** //

//Retro Foils Quantity

const retroQuantity = document.getElementById("retro-quantity");

let retroQuantityValue;

if ("retroFoilsQuant" in sessionStorage) {
		retroQuantity.value = sessionStorage.getItem("retroFoilsQuant");
		retroQuantityValue = retroQuantity.value;
} else {
	retroQuantity.value = 1;
	retroQuantityValue = retroQuantity.value;
}

sessionStorage.setItem("retroFoilsQuant", retroQuantity.value);



function updateSessionData(key, value) {
    // 1. Update sessionStorage
    sessionStorage.setItem(key, value);

    // 2. Dispatch a custom event manually to notify listeners in the same window
    const event = new CustomEvent('sessionStorageUpdated', {
        detail: {
            key: key,
            newValue: value
        }
    });
    window.dispatchEvent(event);
}


//Retro Foils Total Item Cost

var retroFoilsCost = document.getElementById("retro-item-cost");



// ************* Subtotal, Shipping, Tax, & Final Total Amount ************** //

//Subtotal

var subtotal = document.getElementById("subtotal");

//Shipping

var shipping = document.getElementById("shipping-amt");

//Tax

var tax = document.getElementById("tax-amt");

//Final Total Amount

var finalTotalAmt = document.getElementById("total");



// ************* Format Amounts To US Dollar/Cents ************** //

function formatToDollarAmount(value) {
  // Create a NumberFormat instance for US dollars.
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  });

  // Format the value
  return formatter.format(value);
}



// *********************************************** Integrate Stripe Checkout ************************************************* //


const stripe = Stripe('pk_live_51RlotfDNzN3L4AuDWkFmhFOCTkkua2layiYrOukvN5rSr1Hn2qYozQDvY9Sxg0LVKzvyYTFVwUWZm15Ql4sQVOmb00a5LPT9xc');


let checkout;

let actions;

let checkoutSessionID;

let updatedEmail;

let newQuantity;

let shippingDetails;

let finalTotal;

let tryingToPay = 0;


// ********************* BEGIN: JS for "Remove" Button ********************** //


const removeButton = document.getElementById('remove-button');


removeButton.addEventListener('click', async function() {
	
	//console.log("Remove button clicked");

	// ****** Stripe Expire Checkout Lambda ****** //

	const expiredResponse = await fetch('https://ygek336ingvx6z7qne3mohnjqe0karqp.lambda-url.us-east-2.on.aws/', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      checkout_session_id: checkoutSessionID,
    }),
  });

  const response = await expiredResponse.json();
  //console.log('expiredResponse: ', response);
  
  if (response.result == 'success') {
		updateSessionData('retroFoilsQuant', 0);

		/* Use 'replace' below so that user cannot go back to the Checkout page one there is no longer items in it */
		window.location.replace("order.html")
  }
});

// ********************* END: JS for "Remove" Button ********************** //

const emailInput = document.getElementById("payment-email");
const emailErrors = document.getElementById("payment-email-errors");


let shippingAddressElement;
const shippingErrors = document.getElementById('shipping-address-errors');


let billingAddressElement;
const billingErrors = document.getElementById('billing-address-errors');


//document.querySelector("#payment-form").addEventListener("submit", handleSubmit);


initialize();


async function initialize() {


	// ************ BEGIN: Stripe Create Checkout Lambda & Response ************ //

	const response = await fetch('https://uh2llusamwa6t42ob7pqywio5i0vleky.lambda-url.us-east-2.on.aws/', {
    method: 'POST',
  });

  const {clientSecret, sessionID} = await response.json();
  
  //console.log('clientSecret: ', clientSecret);
  //console.log('sessionID: ', sessionID);

  checkoutSessionID = sessionID;

  // ************ END: Stripe Create Checkout Lambda & Response ************ //

	const appearance = {
		theme: 'flat',
  	variables: { 
  		colorPrimaryText: '#262626',
  		colorPrimary: '#EBD5CF',
  		colorBackground: '#F6F8FA',
  	},
  	primaryButton: {
  		backgroundColor: '#D7B9B0',
  	}
	}

	// *** Initialize Stripe Checkout Session After Receiving Client Secret From Lambda *** //

  checkout = stripe.initCheckout({
    clientSecret: clientSecret,
    elementsOptions: { appearance },
  });


	// Handle changes to the checkout session

	checkout.on('change', (session) => {

    //console.log("Checkout Data Changed: ", session);

		retroFoilsCost.innerHTML = session.lineItems[0].subtotal.amount;

		subtotal.innerHTML = session.total.subtotal.amount;

		shipping.innerHTML = session.total.shippingRate.amount;

		tax.innerHTML = session.total.taxExclusive.amount;

		finalTotalAmt.innerHTML = session.total.total.amount;

		finalTotal = session.total.total.amount;

		if (tryingToPay === 1) {
			document.querySelector("#payment-submit-button").textContent = `Processing Payment...`;
		} else {
			document.querySelector("#payment-submit-button").textContent = `Pay ${session.total.total.amount} Now`;
		}
	});



	const loadActionsResult = await checkout.loadActions();


  if (loadActionsResult.type === 'success') {

    actions = loadActionsResult.actions;
    //console.log("Actions: ", actions);


    const initialSession = actions.getSession();
    //console.log("Load Actions Initial Session: ", initialSession);


    const retroLineItemId = initialSession.lineItems[0].id;
		//console.log("Retro Foils Line Item ID: ", retroLineItemId);


		if (sessionStorage.getItem("retroFoilsQuant") !== null) {

   		const lineItem = retroLineItemId;

	  	const selectedValue = sessionStorage.getItem("retroFoilsQuant");

	  	newQuantity = Number(selectedValue);

			actions.updateLineItemQuantity({
		    lineItem,
		    quantity: newQuantity,
		  })

		};

   	
   	retroQuantity.addEventListener('change', async function() {

   		const lineItem = retroLineItemId;

			const selectedValue = this.value;
	  	//console.log('New Selected value:', selectedValue);

	  	sessionStorage.setItem("retroFoilsQuant", selectedValue);

	  	newQuantity = Number(selectedValue);

			actions.updateLineItemQuantity({
		    lineItem,
		    quantity: newQuantity,
		  })

			updateSessionData('retroFoilsQuant', selectedValue);

			const updateShipping = () => fetch("https://vrynjzac4zsntw4o3xawk7f3sq0lrbie.lambda-url.us-east-2.on.aws/", {
		    method: "POST",
		    body: JSON.stringify({
		      checkout_session_id: checkoutSessionID,
		      shipping_details: shippingDetails,
		      quantity: newQuantity,
		    })
		  })

			const response = await actions.runServerUpdate(updateShipping);  // most important line of code to update shipping in checkout data
		});


	} else {
		const {error} = loadActionsResult;
		console.log("Load Actions Error: ", error);
	}

	
// ************************ Email Address Functions ************************ //

  
  emailInput.addEventListener("input", () => {

  	//console.log("Inputting email");

    // Clear any validation errors

    emailErrors.textContent = "";

    emailInput.classList.remove("error");
  });

  
  emailInput.addEventListener("blur", async () => {

    const newEmail = emailInput.value;

    if (!newEmail) {
      return;
    }

    const { isValid, message } = await validateEmail(newEmail);

    if (!isValid) {
      emailInput.classList.add("error");
      emailErrors.textContent = message;
    }
  });


// ************* Shipping Address, Billing Address, & Payment Elements ************* //

  
  const elements = stripe.elements({ appearance });
  //console.log("Elements: ", elements);


  // *** Shipping Address *** //

  shippingAddressElement = elements.create("address", {
  	mode: "shipping",
	});

	shippingAddressElement.mount('#shipping-address-element');

	
	// *** Billing Address *** //
	
	billingAddressElement = elements.create('address', {
  	mode: 'billing',
	});

  billingAddressElement.mount("#billing-address-element");


	// *** Payment Methods *** //

	const paymentElement = checkout.createPaymentElement();
  	
  paymentElement.mount("#payment-element");



	// ************************* BEGIN: Update Shipping Costs & Tax If Shipping Address Changes ************************* //

	
	shippingAddressElement.on('change', async (event) => {

		//console.log("In ShippingAddressElement Change Function");

  	if (event.complete) {
    
	    // The Address Element is complete & valid
	    //console.log('Shipping address is complete:', event.value);
	    //console.log('Shipping State is:', event.value.address.state);
	    //console.log('Shipping Zip is:', event.value.address.postal_code);

	    shippingDetails = event.value;

	    // ****** Stripe Shipping Cost Lambda ****** //

		  const updateShipping = () => fetch("https://vrynjzac4zsntw4o3xawk7f3sq0lrbie.lambda-url.us-east-2.on.aws/", {
		    method: "POST",
		    body: JSON.stringify({
		      checkout_session_id: checkoutSessionID,
		      shipping_details: shippingDetails,
		      quantity: newQuantity,
		    })
		  })

			const response = await actions.runServerUpdate(updateShipping);  // most important line of code to update shipping in checkout data

		  if (response.type === 'error') {
		  	shippingErrors.textContent = response.message;
		    return Promise.resolve({type: "reject", errorMessage: response.message});
		  } else {
		    //console.log("Updatede Shipping Address on Server");
		   	// Clear error message
    		shippingErrors.textContent = '';
		    return Promise.resolve({type: "accept"});
		  }
		}		

	});

	// ************************* END: Update Shipping Costs & Tax If Shipping Address Changes ************************* //


}; // *** end initialize() function *** //


const validateEmail = async (email) => {

  	const updateEmailResult = await actions.updateEmail(email);

		//console.log("Updated Email Address: ", updateEmailResult);

  	const isValid = updateEmailResult.type !== "error";

  	return { isValid, message: !isValid ? updateEmailResult.error.message : null };
};


// ************************ Submit Payment ************************ //

const pmtButton = document.getElementById("payment-submit-button");


pmtButton.addEventListener('click', async (event) => {


 //async function handleSubmit(e) {

  event.preventDefault();

  //console.log("Payment Button Clicked");

  tryingToPay = 1;

  setLoading(true);

  const email = document.getElementById("payment-email").value;
  
  const { isValid, message } = await validateEmail(email);
  
  if (!isValid) {
    emailInput.classList.add("error");
    emailErrors.textContent = message;
    showMessage(message);
    setLoading(false);
    return;
  }


	shippingAddressElement.getValue();


	billingAddressElement.getValue();


  const { error } = await actions.confirm();

  // This point will only be reached if there is an immediate error when
  // confirming the payment. Otherwise, customer will be redirected to
  // the success page.

  if (error.message) {

  	tryingToPay = 0;

		document.querySelector("#payment-submit-button").textContent = `Pay ${finalTotal} Now`;

  	showMessage(error.message);
  }

  setLoading(false);
  
});


// ------- UI helpers -------

function showMessage(messageText) {

  const messageContainer = document.querySelector("#payment-message");

  messageContainer.classList.remove("hidden");
  messageContainer.textContent = `Payment Issue: ${messageText}`;

  //console.log("Payment Error Message: ", messageText);

  setTimeout(function () {
    messageContainer.classList.add("hidden");
    messageContainer.textContent = "";
  }, 5000);
}

// Show a spinner on payment submission
function setLoading(isLoading) {

  if (isLoading) {
  	pmtButton.innerHTML= "Processing Payment...";
    document.querySelector("#payment-submit-button").disabled = true;
  } else {
    document.querySelector("#payment-submit-button").disabled = false;
    //document.querySelector("#payment-submit-button").textContent = `Pay ${finalTotal} Now`;
  }
}